import * as Combobox from '@givebutter/primitives/combobox';
import { TaskAssignee } from 'components/tasks/TaskAssignee';
import { CrmMember } from 'types/domain';

interface CrmMemberComboboxItemProps extends Omit<Combobox.ComboboxItemProps, 'value'> {
    member: CrmMember;
}
const CrmMemberComboboxItem = ({ member, ...restProps }: CrmMemberComboboxItemProps) => {
    return (
        <Combobox.Item key={member.id} value={member.id.toString()} {...restProps}>
            <Combobox.CheckboxIndicator />
            <Combobox.ItemText>
                <TaskAssignee assignee={member} />
            </Combobox.ItemText>
        </Combobox.Item>
    );
};

export { CrmMemberComboboxItem };
export type { CrmMemberComboboxItemProps };
